import { Field, Flags } from "components/shared/form";
import { feedbackTagFlags } from "helpers/enums";
import React, { useState } from "react";
import { apply } from "sources/books/admin/feedbackTags";

export default function FeedbackTagsForm(props) {
    const [data, setData] = useState(props.data || { flags: 0, name: "" });
    const [loading, setLoading] = useState(false);
    const handleSubmit = () => {
        setLoading(true);
        apply(data).then((res) => {
            if (res) {
                props.back();
            }
            setLoading(false);
        });
    };

    return (
        <div className={loading ? "loading" : ""}>
            <Field
                label="Название"
                inputProps={{ name: "name" }}
                onChange={({ name, value }) => setData({ ...data, [name]: value })}
                value={data.name}
            />
            <Flags
                label="Настройки"
                inputProps={{ name: "flags" }}
                flags={feedbackTagFlags}
                value={data.flags}
                onChange={({ name, value }) => setData({ ...data, [name]: value })}
            />
            <div className="d-flex justify-content-end">
                <div className="btn btn-sm btn-brand" onClick={handleSubmit}>
                    Сохранить
                </div>
            </div>
        </div>
    );
}
